import Contact, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/contact';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Contact;
